import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ANightInParis from "./sections/ANightInParis";
import ArtOfTheSoiree from "./sections/ArtOfTheSoiree";
import TheDesignPhilosophy from "./sections/TheDesignPhilosophy";
import SensoryDetails from "./sections/SensoryDetails";
import IndustryPraise from "./sections/IndustryPraise";
import BeginYourRecovery from "./sections/BeginYourRecovery";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ANightInParis />
      <ArtOfTheSoiree />
      <TheDesignPhilosophy />
      <SensoryDetails />
      <IndustryPraise />
      <BeginYourRecovery />
      <MainSiteFooter />
    </div>;
}